import { Icon, IIconName } from '@features/siteStatusV2/components/icon';
import theme, { ThemeVariants } from '@theme';
import React from 'react';
import styled from 'styled-components';

export interface HeaderBadgeProps {
  color: ThemeVariants;
  label: string;
  icon?: IIconName;
}

interface HeaderBadgesProps {
  badges: HeaderBadgeProps[];
}

const HeaderBadges: React.FC<HeaderBadgesProps> = ({ badges }) => {
  return (
    <BadgeListContainer>
      {badges.map((badge, index) => (
        <React.Fragment key={badge.label}>
          <BadgeContainer color={badge.color}>
            {badge.icon && (
              <>
                <CustomIconContainer>
                  <CustomIcon color={badge.color} iconName={badge.icon.iconName} />
                </CustomIconContainer>{' '}
              </>
            )}
            {badge.label}
          </BadgeContainer>
          {index < badges.length - 1 && <Separator />}
        </React.Fragment>
      ))}
    </BadgeListContainer>
  );
};

const Separator = styled.div`
  width: 0.188rem;
  height: 0.188rem;
  background: ${theme.palette.grey[300]};
  border-radius: 50%;
  margin-right: 0.375rem;
`;

const BadgeListContainer = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const BadgeContainer = styled.span<{ color: ThemeVariants }>`
  width: fit-content;
  height: 1rem;
  border-radius: 0.25rem;
  background-color: ${(props) => {
    return theme.palette[props.color][100];
  }};
  font-size: 0.563rem;
  line-height: 0.75rem;
  font-weight: 500;
  text-align: center;
  text-wrap: nowrap;
  color: ${(props) => {
    return theme.palette[props.color][400];
  }};
  padding-left: 0.375rem;
  padding-right: 0.25rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  margin-right: 0.375rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const CustomIconContainer = styled.div`
  width: 0.563rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.125rem;
`;

const CustomIcon = styled(Icon)<{ color: ThemeVariants }>`
  color: ${(props) => {
    return theme.palette[props.color][400];
  }};
  height: 0.563rem;
  stroke-width: 2;
`;

export default HeaderBadges;
